import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputLabel from "@material-ui/core/InputLabel";
// core components
import GridItem from "../../../components/Grid/GridItem.jsx";
import GridContainer from "../../../components/Grid/GridContainer.jsx";
import Button from "../../../components/CustomButtons/Button";
import Snackbar from "../../../components/Snackbar/Snackbar";
// @material-ui/core icons
import NotificationErrorIcon from "@material-ui/icons/Error";
import NotificationFailedIcon from "@material-ui/icons/Cancel";
import NotificationSuccessIcon from "@material-ui/icons/DoneAll";
// @material-ui/react-select
import Select from "../../../components/CustomSelect/CustomSelect";
import makeAnimated from "react-select/animated";
// Models & service
// Styles
import formStyle from "../../../assets/jss/custom-components/formStyle";
import {NOTIFICATION_DURATION} from "../../../variables/coreConstants";
import {
    disableComponent,
    enableComponent,
    getData, isSuccessfulCreate,
    selectValidation,
} from "../../../utils/helpersFunctions";
import {primaryColor} from "../../../assets/jss/material-dashboard-react";
import {validateSession} from "../../../services/api";
import {withRouter} from "react-router-dom";
import {withTranslation} from "react-i18next";
import {addDiscountStoreAssigment, getStoresAvailableToDiscount} from "../../../services/discountService";


const animatedComponents = makeAnimated();

class StoreDiscountAssignmentForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            store: '',
            storeOptions: [],
            loadingStores: true,
            notificationMessage: '',
            notification: false,
            color: 'success',
            icon: NotificationSuccessIcon,
            disableField: false,
        };
        this.assignStore = this.assignStore.bind(this);
        this.cleanData = this.cleanData.bind(this);
    }

    componentDidMount() {
        this.request();
    }

    changeStoreSelect = store => {
        this.setState({ store } );
    };

    cleanData() {
        this.setState({
            store: '',
        });
    }

    showNotification = (msj, color, icon, refresh) => {
        this.setState({
            notificationMessage: msj,
            color: color,
            icon: icon,
            notification: true,
        });

        window.setTimeout(
            function() {
                this.setState({ notification: false });

                if (refresh != null) {
                    this.props.closeForm("openStore", false, refresh);
                }
            }.bind(this),
            NOTIFICATION_DURATION
        );
    };

    hideNotification = (event, reason) => {
        if (reason === 'clickaway') { return }
        this.setState({ notification: false });
    };


    request() {
        let discount = getData("discount");
        let storeValues;

        getStoresAvailableToDiscount(discount.uuid)
            .then((res) => {
                storeValues = res.data.map( item => {
                    return { value: item.id , label: item.name };
                });
                this.setState({
                    storeOptions: storeValues,
                    loadingStores: false
                });
            })
            .catch((err) => {
                this.setState({ loadingStores: false} );
                if (err.response) {
                    this.showNotification(err.response.data.message, "danger", NotificationFailedIcon, null);
                    validateSession(err.response, this.props.history);
                } else {
                    this.showNotification(this.props.t('SOMETHING_WENT_WRONG'), "danger", NotificationFailedIcon, null);
                }
            });
    }


    assignStore() {
        const { t } = this.props;

        if (selectValidation(this.state.store)) {
            this.showNotification(t('STORE_REQUIRED_MSG'), "danger", NotificationErrorIcon, null);

        } else {
            let discount = getData("discount");
            let storesId= this.state.store.map( item => {
                return { uuid: item.value };
            });

            let dataParameters = {
                "discountId": discount.uuid,
                "stores": JSON.stringify(storesId)
            };

            disableComponent(this, "disableField");
            addDiscountStoreAssigment(dataParameters)
                .then((response) => {
                    if (isSuccessfulCreate(response)) {
                        this.cleanData();
                        this.showNotification(response.data.message, "primary", NotificationSuccessIcon, true);

                    } else {
                        enableComponent(this, "disableField");
                        this.showNotification(response.data.message, "danger", NotificationErrorIcon, null);
                    }
                })
                .catch(error => {
                    enableComponent(this, "disableField");
                    if (error.response) {
                        this.showNotification(error.response.data.message, "danger", NotificationFailedIcon, null);
                        validateSession(error.response, this.props.history);
                    } else {
                        this.showNotification(this.props.t('SOMETHING_WENT_WRONG'), "danger", NotificationFailedIcon, null);
                    }
                });
        }
    }


    render(){
        const { classes, t } = this.props;
        const { loadingStores, disableField } = this.state;

        const AssignStoreButton = () => (
            <Button
                color="primary"
                className={classes.buttonSpacing}
                onClick={() => this.assignStore()}
                disabled={disableField || loadingStores}
            >
                {t('BTN_ASSIGN')}
            </Button>
        );

        return (
            <div className={classes.formContainer}>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <div className={classes.selectControlMax}>
                            <InputLabel htmlFor="asset" className={classes.selectTitle}>
                                {t('STORES_TEXT')}
                            </InputLabel>
                            <Select
                                value={this.state.store}
                                onChange={this.changeStoreSelect}
                                components={animatedComponents}
                                options={this.state.storeOptions}
                                placeholder={t('SELECT_TEXT')}
                                isMulti={true}
                                isClearable={true}
                                isDisabled={loadingStores || disableField}
                                isLoading={loadingStores || disableField}
                                maxMenuHeight={100}
                                closeMenuOnSelect={false}
                                theme={theme => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary: primaryColor[0],
                                    },
                                })}
                            />
                        </div>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                        <div className={classes.rightPaper}>
                            <Button
                                color="white"
                                className={classes.buttonSpacing + " " + classes.cancelButton}
                                onClick={() => this.props.closeForm("openStore", false, false)}
                            >
                                {t('BTN_CANCEL')}
                            </Button>
                            <AssignStoreButton/>
                        </div>
                    </GridItem>
                    <Snackbar
                        place="tc"
                        color={this.state.color}
                        icon={this.state.icon}
                        message={this.state.notificationMessage}
                        open={this.state.notification}
                        closeNotification={this.hideNotification}
                        close
                    />
                </GridContainer>
            </div>
        );
    }
}

StoreDiscountAssignmentForm.propTypes = {
    classes: PropTypes.object
};

export default withRouter(withStyles(formStyle)(withTranslation()(StoreDiscountAssignmentForm)));